export default __webpack_public_path__ + "static/media/product_test_discovery_cic.c765be9c.jpg";